export default __webpack_public_path__ + "static/media/dex-tools.68fbb3f6.png";